import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiClock } from 'react-icons/fi';
import { useContent } from '../context/ContentContext';
import './Blog.css';

const BlogPreview = () => {
  const { blogs } = useContent();
  const list = blogs.slice(0, 3);
  if (!list.length) return null;

  return (
    <section className="blog section">
      <div className="container">
        <div className="section-header">
          <span className="section-eyebrow">Insights</span>
          <h2 className="section-title section-title--center">
            From the THINKINGWORLD blog.
          </h2>
          <p className="section-lead section-lead--center">
            Notes on engineering, design, marketing and the practical realities
            of running a modern business online.
          </p>
        </div>

        <div className="blog-grid">
          {list.map((p) => (
            <Link key={p.id} to={`/resources/blog/${p.slug || p.id}`} className="blog-card">
              <div className="blog-cover">
                {p.cover ? (
                  <img
                    src={p.cover}
                    alt={p.title}
                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                  />
                ) : (
                  <div className="blog-cover-placeholder" />
                )}
                <span className="blog-category">{p.category}</span>
              </div>
              <div className="blog-body">
                <div className="blog-meta">
                  <span>{p.date}</span>
                  <span><FiClock /> {p.readTime}</span>
                </div>
                <h3 className="blog-title">{p.title}</h3>
                <p className="blog-excerpt">{p.excerpt}</p>
                <span className="blog-link">
                  Read article <FiArrowRight />
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="blog-foot">
          <Link to="/resources/blog" className="btn btn-ghost">
            See all articles <FiArrowRight />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BlogPreview;
